import { AccountBillingSettingsSchema, DashpivotBillingSettingsSchema, FlowsiteBillingSettingsSchema, } from './billing-settings.model';
// Prefer `pick` than `omit` so we're explicit about what we want to include.
export var UpdateAccountBillingSettingsRequestDtoSchema = AccountBillingSettingsSchema.pick({
    billingCompanyName: true,
    billingAddress: true,
    billingContact: true,
    billingDate: true,
    initialSubscriptionDate: true,
    paymentTermDay: true,
    paymentTermContext: true,
    paymentMethod: true,
    currency: true,
});
export var UpdateDashpivotBillingSettingsRequestDtoSchema = DashpivotBillingSettingsSchema.pick({
    trialEndDate: true,
    planType: true,
    subscriptionStatus: true,
    initialSubscriptionDate: true,
    subscriptionTerm: true,
    billingCycle: true,
    contributorUsersPaid: true,
    sitematePaidUsersPaid: true,
});
export var UpdateFlowsiteBillingSettingsRequestDtoSchema = FlowsiteBillingSettingsSchema.pick({
    trialEndDate: true,
    planType: true,
    subscriptionStatus: true,
    initialSubscriptionDate: true,
    subscriptionTerm: true,
    billingCycle: true,
});
